module.exports = __webpack_public_path__ + "img/bgdiamond.651cbbe2.jpeg";